/**
 * Enum representing the status of the Flagship SDK.
 */
export var FSSdkStatus;
(function (FSSdkStatus) {
    /**
     * It is the default initial status. This status remains until the sdk has been initialized successfully.
     */
    FSSdkStatus[FSSdkStatus["SDK_NOT_INITIALIZED"] = 0] = "SDK_NOT_INITIALIZED";
    /**
     * The SDK is currently initializing.
     */
    FSSdkStatus[FSSdkStatus["SDK_INITIALIZING"] = 1] = "SDK_INITIALIZING";
    /**
     * Flagship SDK is ready but is running in Panic mode: All features are disabled except the one which refresh this status.
     */
    FSSdkStatus[FSSdkStatus["SDK_PANIC"] = 2] = "SDK_PANIC";
    /**
     * The Initialization is done, and Flagship SDK is ready to use.
     */
    FSSdkStatus[FSSdkStatus["SDK_INITIALIZED"] = 3] = "SDK_INITIALIZED";
})(FSSdkStatus || (FSSdkStatus = {}));
